import * as React from 'react';

import BaseSettingsTeamLayout from './BaseSettingsTeamLayout';
import UserEditPopup from '../containers/users/UserEditPopup';

export default function ({ userId }) {
  return BaseSettingsTeamLayout(
    <UserEditPopup userId={userId} />
  );
};
